var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownSFillFull = function SvgArrowDownSFillFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: "arrow-down-s-fill-full_svg__!w-full arrow-down-s-fill-full_svg__!h-auto",
    viewBox: "7 9 11 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.7 7.1 9.3h10.8z"
  })));
};
export default SvgArrowDownSFillFull;